import React from 'react';

import { useConfig } from '../config';

export function TestEnvBannerComponent(): JSX.Element | null {
  const { env } = useConfig();
  const isTestEnv = !['prod'].includes(env);

  return isTestEnv ? (
    <div className="text-white bg-danger text-center p-2 text-wrap sticky-top">
      Non-Production: Do not enter Personally Identifiable Information (PII) or
      Protected Health Information (PHI).
    </div>
  ) : null;
}

export default TestEnvBannerComponent;
